const MIN_RADIUS = 15;
const MAX_RADIUS = 20;

/**
 * Returns 10% of the bar width if within the bounds
 * If too large, returns the max radius
 * If too small, returns the minimum radius, or 35% of the bar width
 */
export const getAvatarRadius = (barWidth: number) => {
  const radius = barWidth * 0.1;
  if (radius > MAX_RADIUS) return MAX_RADIUS;
  if (radius < MIN_RADIUS) return Math.min(MIN_RADIUS, barWidth * 0.35);
  return radius;
};

export const getAvatarPadding = (avatarRadius: number) => avatarRadius * 1.5;

export const getAvatarTotalHeight = (barWidth: number) => {
  const avatarRadius = getAvatarRadius(barWidth);
  const avatarPadding = avatarRadius * 1.5;

  return avatarPadding + avatarRadius;
};

export const getAvatarsToRender = (
  totalIdentities: number,
  maxNumberOfVisibleAvatars: number,
): { numberOfVisibleAvatars: number; numberOfExtraAvatars: number } => {
  if (maxNumberOfVisibleAvatars === 1) {
    return { numberOfVisibleAvatars: 1, numberOfExtraAvatars: 0 };
  }
  if (totalIdentities > maxNumberOfVisibleAvatars) {
    return {
      numberOfVisibleAvatars: maxNumberOfVisibleAvatars - 1,
      numberOfExtraAvatars: totalIdentities - maxNumberOfVisibleAvatars + 1,
    };
  }
  return { numberOfVisibleAvatars: totalIdentities, numberOfExtraAvatars: 0 };
};
